import { render, staticRenderFns } from "./updateWuliao.vue?vue&type=template&id=16e4e93b&scoped=true&"
import script from "./updateWuliao.vue?vue&type=script&lang=js&"
export * from "./updateWuliao.vue?vue&type=script&lang=js&"
import style0 from "./updateWuliao.vue?vue&type=style&index=0&id=16e4e93b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e4e93b",
  null
  
)

export default component.exports